import React, { Component } from "react";
import L from "leaflet";
import "leaflet.gridlayer.googlemutant";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import redicon from "../../Images/marker-icon.png";
import greenicon from "../../Images/PickupIcon.png";
import "leaflet/dist/leaflet.css";
import "leaflet-routing-machine";

class MapDirection extends Component {
  constructor(props) {
    super(props);
    this.marker = {};
    this.ID = "multimap";
  }

  componentDidMount() {
    let origin = {};
    origin = {
      lat: this.props.source?.lat,
      lng: this.props.source?.lng,
    };
    this.initializeMap(true, origin);
  }

  initializeMap = async (createMap, origin) => {
    if (createMap) {
      this.map = L.map(this.ID, {
        zoom: 10,
        center: origin,
        attributionControl: false,
      });
      var googleHybrid = L.tileLayer(
        "http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}",
        {
          maxZoom: 20,
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
        }
      );
      var googleStreets = L.tileLayer(
        "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
        {
          maxZoom: 20,
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
        }
      );
      var googleTraffic = L.tileLayer(
        "https://{s}.google.com/vt/lyrs=m@221097413,traffic&x={x}&y={y}&z={z}",
        {
          maxZoom: 20,
          minZoom: 2,
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
        }
      );

      var baseMaps = {
        Default: googleStreets,
        Satellite: googleHybrid,
        Traffic: googleTraffic,
      };

      var overlays = {};
      L.control
        .layers(baseMaps, overlays, { position: "topright" })
        .addTo(this.map);
      L.gridLayer
        .googleMutant({
          maxZoom: 20,
        })
        .addTo(this.map);

      let waypoints = [
        L.latLng(this.props?.source?.lat, this.props?.source?.lng),
        L.latLng(this.props?.lat, this.props?.lng),
      ];

      let icon = L.icon({
        iconUrl: greenicon,
        iconSize: [24, "auto"],
        iconAnchor: [8.5, 32],
        popupAnchor: [0, -32],
      });
      const icon1 = L.icon({
        iconUrl: redicon,
        iconSize: [24, "auto"],
        iconAnchor: [8.5, 32],
        popupAnchor: [0, -32],
      });
      L.Routing.control({
        waypoints,
        plan: L.Routing.plan(waypoints, {
          createMarker: function (i, wp) {
            if (waypoints[0]) {
              return L.marker(wp.latLng, {
                draggable: false,
                icon: i === 0 ? icon : icon1,
              });
            }
          },
          routeWhileDragging: true,
        }),
        lineOptions: {
          styles: [{ color: "#6FA1EC", weight: 6 }],
        },
        show: false,
        addWaypoints: false,
        routeWhileDragging: false,
        draggableWaypoints: false,
        fitSelectedRoutes: false,
        showAlternatives: false,
      }).addTo(this.map);
    } else {
      this.map.eachLayer((layer) => {
        if (layer.feature !== undefined) {
          this.map.removeLayer(layer);
        }
      });
    }
  };

  render() {
    return (
      <div
        style={{
          height: "510px",
          width: "100%",
        }}
      >
        <div id={this.ID} style={{ height: "100%", width: "100%" }} />
      </div>
    );
  }
}

export default MapDirection;
